import "whatwg-fetch";
import Query from "url-query-parser";
import { API_TRANSLATE } from "../constants/translator";

export const translateTextReq = data => {
  const body = Query.stringify({
    type: data.type,
    text: data.text,
    to: data.code,
    from: data.code
  });
  return fetch(API_TRANSLATE, {
    method: "POST",
    body,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
    .then(response => response.json())
    .then(text => text)
    .catch(err => err);
};



// WEBPACK FOOTER //
// ./src/api/translate.js